<template>
  <main>
    <contact-us-blurb />
    <div class="container-fluid bg-white pt-3">
      <div class="container">
        <food-navbar current="fff-recipes" />
      </div>
    </div>
    <div class="container-fluid bg-white pt-5 pb-5">
      <div class="container">
        <div class="page-title-box">
          Food Fitness First Recipes
        </div>

        <div class="page-subheader-box">
          <div class="split">
            <div class="side category">
              {{ paginationParams.total }} Results
            </div>
            <div class="side filter">
              <input
                v-model="recipe_search"
                type="text"
                class="fff-ui"
                placeholder="Search..."
              >
            </div>
          </div>
        </div>

        <div class="container-fluid bg-white pt-4 pb-0 px-0">
          <div class="recipe-grid">
            <pagination
              v-if="recipes.length>0"
              :params="paginationParams"
              @go-to-page="load_recipes"
            />
            <div
              v-for="(recipe, recipe_index) in recipes"
              class="recipe-item"
            >
              <div :class="['box', recipe.image_url ? 'has-image' : '']">
                <div
                  class="image"
                  :style="{'background-image': 'url(' + recipe.image_url + ')'}"
                  @click="show_recipe_details_modal(recipe_index)"
                >
                  <div
                    v-if="recipe.is_favorited"
                    class="favorited"
                  >
                    <i class="fas fa-heart" />
                  </div>
                  <div
                    class="food-factor-circle"
                    :class="[recipe.food_color.toLowerCase()]"
                  >
                    <auto-fit-text>
                      {{ recipe.food_factor }}
                    </auto-fit-text>
                  </div>
                </div>
                <div class="text">
                  <div
                    class="name"
                    @click="show_recipe_details_modal(recipe_index)"
                  >
                    {{ recipe.name }}
                  </div>
                  <button
                    class="button"
                    @click="updatemodalData(recipe); is_showing_add_meal_modal = true; "
                  >
                    Add to Meal Log
                  </button>
                </div>
              </div>
            </div>
            <pagination
              v-if="recipes.length>0"
              :params="paginationParams"
              @go-to-page="load_recipes"
            />
          </div>
        </div>

        <!-- Recipe Details Modal -->
        <recipe-details-modal
          v-if="modal_recipe"
          v-show="is_showing_recipe_details_modal"
          :recipe="modal_recipe"
          @close="hide_recipe_details_modal"
          @toggle-favorite="toggle_favorite"
        >
          <template #actions>
            <button
              class="button fluid"
              @click="updatemodalData(modal_recipe); is_showing_add_meal_modal = true; "
            >
              Add to Meal Log
            </button>
          </template>
        </recipe-details-modal>


        <!-- Add Meal Modal -->
        <add-meal-modal
          v-show="is_showing_add_meal_modal"
          :iteminfo="modalData"
          @hide-modal="is_showing_add_meal_modal = false"
          @meal-log-entry-added="recipe_search = ''"
        />

        <!-- Upgrade Modal -->
        <upgrade-modal
          v-show="is_showing_upgrade_modal"
          @show-modal="is_showing_upgrade_modal = true"
          @hide-modal="is_showing_upgrade_modal = false"
        />
      </div>
    </div>
  </main>
</template>

<script>

import foodcalc from '../components/FoodCalculator'
import FoodSearchShared from "../components/FoodSearchShared";
import RecipeDetailsModal from "../components/RecipeDetailsModal";
import {debounce} from "lodash";

export default {
  name: 'FFFRecipes',
  components: {RecipeDetailsModal},
  data() {
    return {
      recipes: [],
      recipe_count: 0,
      recipe_search: '',
      debounced_load_recipes: null,

      is_showing_recipe_details_modal: false,
      is_showing_add_meal_modal: false,
      is_showing_upgrade_modal: false,

      modal_recipe: false,
      modalData: {},
      paginationParams: {
        current_page: 1,
        total_pages: 1,
        total: 0,
      }
    };
  },
  watch: {
    is_showing_add_meal_modal: function(){
      if (this.$parent.user.type != 'individual') {
        this.is_showing_upgrade_modal = true;
        this.is_showing_add_meal_modal = false;
      }
    },

    recipe_search: function () {
      // Reset to first page on search
      this.paginationParams.current_page = 1;

      this.debounced_load_recipes();
    }
  },
  async mounted () {
    this.load_recipes();

    this.debounced_load_recipes = debounce(this.load_recipes, 500);
  },
  methods: {
    show_recipe_details_modal(recipe_index) {
      var obj_multi = document.querySelectorAll('.container');
      for (const key in obj_multi) {
        if (obj_multi.hasOwnProperty.call(obj_multi, key)) {
          const ele = obj_multi[key];
          if (ele.querySelectorAll('.fff-modal').length === 0) {
            ele.classList.add('dialog-no-print');
          }
        }
      }
      var obj_multi = document.querySelectorAll('.container-fluid');
      for (const key in obj_multi) {
        if (obj_multi.hasOwnProperty.call(obj_multi, key)) {
          const ele = obj_multi[key];
          if (ele.querySelectorAll('.fff-modal').length === 0) {
            ele.classList.add('dialog-no-print');
          }
        }
      }
      this.is_showing_recipe_details_modal = true;
      this.modal_recipe = this.recipes[recipe_index];
    },
    hide_recipe_details_modal() {
      var obj_multi = document.querySelectorAll('.dialog-no-print');
      for (const key in obj_multi) {
        if (obj_multi.hasOwnProperty.call(obj_multi, key)) {
          const ele = obj_multi[key];
          ele.classList.remove('dialog-no-print');
        }
      }
      this.is_showing_recipe_details_modal = false;
    },
    async toggle_favorite(modal_recipe) {
      // API request here

      if (this.$parent.user.type == 'individual') {
        let updateditem = await this.$http('/api/recipe/favorites',{
          method:"post",
          body:JSON.stringify({
            'food_recipe_id':modal_recipe.id
          }),
        }).then(response => response.json())
          .then(async function(json) {
            return json.data;
          });

        modal_recipe.is_favorited = !modal_recipe.is_favorited;
      } else {
        this.is_showing_upgrade_modal = true;
      }

    },
    process_recipes_for_display(recipedata){
      return FoodSearchShared.process_recipes_for_display(recipedata);
    },
    updatemodalData(recipeinfo){
      this.modalData['type']='recipe';
      this.modalData['serving_size']=recipeinfo.display_single;
      this.modalData['serving_unit']=recipeinfo.servings_unit;
      this.modalData['food_recipe_id']=recipeinfo.id;
      this.modalData['meal_name']=recipeinfo.name;			// To change title in modal
      this.modalData = Object.assign({},this.modalData,this.modalData);
      // console.log("modaldata");
      // console.log(this.modalData);
    },
    async load_recipes(page){
      let params = new URLSearchParams();
      params.append('recipe_type', 'fff');

      if (this.recipe_search !== '') {
        params.set('q', this.recipe_search);
      }

      if (page) {
        params.set('page', page);
      }

      let getrecipes = await this.$http('/api/recipe/myrecipes?' + params.toString(),{
        method:"get",
      }).then(response => response.json())
        .then(async function(json) {
          return json;
        });

      if(typeof(getrecipes.data)!='undefined' && getrecipes.data.length >= 0){
        this.recipes = await this.process_recipes_for_display(getrecipes.data);
        this.paginationParams = getrecipes.meta;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
  /* Override gray background */
	.recipe-grid .recipe-item .image {
		background-color: initial;
	}

	.recipe-item .box .food-factor-circle{
		top:5%; left:5%; width:90%; height:90%; font-size:1.2rem;
	}

	/* image_url is present */
	$circle-size: 75px;
	.recipe-item .box.has-image .food-factor-circle {
		padding-bottom:0px; width:$circle-size; height:$circle-size; bottom:-10px; right:8px; top:auto; left:auto;
	}
	.recipe-item .box.has-image .food-factor-circle {
		font-size: 1.7rem; border-width:4px;
	}
</style>
